import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('administrativecenter.header'),
      path: 'masters/society/locations/administrativecenters',
      use_parent_params: true,
      params_required: ['id', 'idSede', 'idCentro'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/society/locations/administrativecenters/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
